import Flex, { GAP_CLASS } from "components/Flex";
import { History } from "lucide-react";
import { useSelector } from "react-redux";
import { selectExtractionReusedFrom } from "slices/proposalOutline/selectors";
import { dateFromArray } from "utils";
import isNullish from "utils/isNullish";

import styles from "./ExtractionReuseWarning.module.scss";

const ExtractionReuseWarning = () => {
  const extractionReusedFrom = useSelector(selectExtractionReusedFrom);
  let reusedFromDate = null;

  if (isNullish(extractionReusedFrom)) {
    return null;
  }

  if (extractionReusedFrom) {
    reusedFromDate = Array.isArray(extractionReusedFrom)
      ? dateFromArray(extractionReusedFrom)
      : new Date(extractionReusedFrom);
  }

  const reusedFromDateValid =
    reusedFromDate && !Number.isNaN(reusedFromDate.getTime());

  return (
    <Flex className={styles.reuseNote} gap={GAP_CLASS.GAP_200}>
      <History size={14} aria-hidden="true" />
      <span>
        Reused from an earlier extraction
        {reusedFromDateValid && (
          <>
            , first extracted{" "}
            {reusedFromDate.toLocaleDateString("en-GB", {
              day: "numeric",
              month: "short",
            })}
          </>
        )}
        .
      </span>
    </Flex>
  );
};

export default ExtractionReuseWarning;
